export { Pagination } from './Pagination'
export type {
  PaginationHookConfig,
  PresetPaginationProps as PaginationProps,
} from './Pagination.types'
